import {
  Directive,
  HostListener,
  ElementRef,
  OnInit,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { PrNumberPipe } from '../pipes/ea-number.pipe';

@Directive({
    selector: '[prColorizeText]',
    standalone: false
})
export class EaColorizeTextDirective implements OnInit {
  @Output() onErrorInput: any = new EventEmitter();
  @Input('prColorizeText') value: any;
  @Input('minThreshold') minThreshold: number = 0;

  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private numberPipe: PrNumberPipe,
  ) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {
    if (this.value >= this.minThreshold) this.el.classList.add('ea-positive');
    else this.el.classList.add('ea-negative');
  }
}
